<template>
  <groupish v-if="group !== null" :value="groupRepresentation" type="group"
            :editable="editable" @input="update"/>
</template>

<script>
  import { mapActions } from 'vuex';
  import Groupish from '../shared/groupish/Groupish';

  export default {
    components: { Groupish },
    props: ['id'],
    data() {
      return {
        group: null
      };
    },
    computed: {
      editable() {
        return this.$auth.hasPermission('EDIT_ALL_USERS');
      },
      groupRepresentation() {
        return {
          id: this.group.id,
          name: this.group.name,
          servicePermissions: this.group.servicePermissions,
          approvers: [this.group.user],
          members: this.group.members,
          groups: []
        };
      }
    },
    methods: {
      update(val) {
        this.group = {
          id: val.id,
          name: val.name,
          servicePermissions: val.servicePermissions,
          user: val.approvers.length ? val.approvers[0] : null,
          members: val.members
        };
        this.$services.authenticator.put(`/groups/${this.id}`, this.group)
          .then(() => this.show('Group updated'))
          .catch(this.$defaultHandlerHttp);
      },
      ...mapActions('alert', [
        'show'
      ])
    },
    mounted() {
      this.$services.authenticator.get(`/groups/${this.id}`)
        .then((res) => this.group = res.data.data)
        .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less" scoped>
</style>
